import { computed } from 'mobx';

/**
 * 기계자재내역 모델
 * @window w_tb_e450_bom_15
 * @category 견적리모델링제품등록
 */
export class MachineModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 관급사급구분
   *
   * **data type** varchar(1)
   */
  readonly pgubun: string;

  /**
   * 순번
   *
   * **data type** varchar(3)
   */
  readonly seq: string;

  /**
   * 품명코드
   *
   * **data type** varchar(50)
   */
  readonly pcode: string;

  /**
   * 품명
   *
   * **data type** varchar(255)
   */
  readonly pname: string;

  /**
   * 규격
   *
   * **data type** varchar(255)
   */
  readonly psize: string;

  /**
   * 단위
   *
   * **data type** varchar(50)
   */
  readonly punit: string;

  /**
   * 단가
   *
   * **data type** float
   */
  readonly uamt: string;

  /**
   * 사용유무
   *
   * **data type** char(1)
   */
  readonly useyn: string;

  /**
   * 비고
   *
   * **data type** varchar(100)
   */
  readonly remark: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  readonly inperid: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  readonly indate: string;

  /**
   * 대분류명
   *
   * **data type** varchar(50)
   */
  readonly phm_sgrbnm: string;

  readonly new: string;


  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.pgubun = data.pgubun || '';
    this.seq = data.seq || '';
    this.pcode = data.pcode || '';
    this.pname = data.pname || '';
    this.psize = data.psize || '';
    this.punit = data.punit || '';
    this.uamt = data.uamt || '';
    this.useyn = data.useyn || '';
    this.remark = data.remark || '';
    this.inperid = data.inperid || '';
    this.indate = data.indate || '';
    this.phm_sgrbnm = data.phm_sgrbnm || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
